import { defineStore } from 'pinia'

export default defineStore({
  id: 'library',
  persist: true,
  state: () => {
    return {
      locations: []
    }
  },
  actions: {
    clear: function () { },
    setLocations: function (payload: any) {
      this.locations = payload || []
    }
  },
  getters: {}
})
